(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floris-avis-liste"] && !Shopify.designMode) return;
  try {
    
/* PAGINATION, TRI, DEPLIEMENT ET FORMULAIRE.
   TOUT EST SOUS `.av2-js`, classe que seul ce script pose : sans lui la section
   affiche la premiere page et rien d'autre, la pagination restant masquee. Un
   visiteur sans JavaScript voit donc six avis complets plutot qu'une liste
   tronquee avec des boutons morts.

   LE DEPLIEMENT NE S'ANNONCE QUE S'IL SERT. `scrollHeight > clientHeight` est
   la seule mesure qui dise si la coupe a vraiment eu lieu : un avis de deux
   lignes n'a rien a deplier, et lui coller un « voir tout l'avis » est le detail
   qui fait faux. La marge de 4 px absorbe l'arrondi sous-pixel. */
(function () {
  function armer(sec) {
    if (!sec || sec.getAttribute('data-av2-arme') === '1') return;
    var liste = sec.querySelector('[data-av2-liste]');
    if (!liste) return;
    sec.setAttribute('data-av2-arme', '1');
    sec.classList.add('av2-js');

    var parPage = parseInt(sec.getAttribute('data-av2-par-page'), 10) || 6;
    var items = [].slice.call(liste.children);
    var boutons = [].slice.call(sec.querySelectorAll('[data-av2-page]'));
    var suivant = sec.querySelector('[data-av2-suivant]');
    var page = 1;

    function pages() {
      return Math.max(1, Math.ceil(items.length / parPage));
    }

    function afficher(p) {
      page = Math.min(Math.max(1, p), pages());
      var debut = (page - 1) * parPage;
      var fin = debut + parPage;
      /* On repart de l'ordre COURANT du DOM et non du tableau d'origine :
         apres un tri, les deux ne coincident plus. */
      var courants = [].slice.call(liste.children);
      for (var i = 0; i < courants.length; i++) {
        if (i >= debut && i < fin) {
          courants[i].removeAttribute('hidden');
        } else {
          courants[i].setAttribute('hidden', '');
        }
      }
      for (var j = 0; j < boutons.length; j++) {
        var actif = parseInt(boutons[j].getAttribute('data-av2-page'), 10) === page;
        boutons[j].className = actif ? 'av2-page on' : 'av2-page';
        if (actif) { boutons[j].setAttribute('aria-current', 'page'); }
        else { boutons[j].removeAttribute('aria-current'); }
      }
      mesurerCoupes();
    }

    /* On ne remonte pas en haut de la PAGE mais en haut de la LISTE, et
       seulement quand elle est deja passee au-dessus de l'ecran : changer de
       page en gardant l'oeil au milieu d'un avis donne l'impression que rien
       ne s'est passe. */
    function recadrer() {
      var haut = liste.getBoundingClientRect().top;
      if (haut < 0) { window.scrollTo({ top: window.scrollY + haut - 90, behavior: 'smooth' }); }
    }

    for (var k = 0; k < boutons.length; k++) {
      (function (b) {
        b.addEventListener('click', function () {
          afficher(parseInt(b.getAttribute('data-av2-page'), 10));
          recadrer();
        });
      })(boutons[k]);
    }
    if (suivant) {
      suivant.addEventListener('click', function () {
        afficher(page >= pages() ? 1 : page + 1);
        recadrer();
      });
    }

    /* DEPLIEMENT. On ne mesure que les avis VISIBLES : un element `hidden` a
       une hauteur nulle, la comparaison y serait toujours fausse et tous les
       boutons apparaitraient. D'ou l'appel a chaque changement de page. */
    function mesurerCoupes() {
      var vus = liste.querySelectorAll('.av2-item:not([hidden])');
      for (var i = 0; i < vus.length; i++) {
        var zone = vus[i].querySelector('[data-av2-texte]');
        var btn = vus[i].querySelector('[data-av2-plus]');
        if (!zone || !btn) continue;
        if (zone.className.indexOf('tout') !== -1) continue;
        if (zone.scrollHeight - zone.clientHeight > 4) {
          btn.removeAttribute('hidden');
        } else {
          btn.setAttribute('hidden', '');
        }
      }
    }

    liste.addEventListener('click', function (ev) {
      var btn = ev.target.closest ? ev.target.closest('[data-av2-plus]') : null;
      if (!btn) return;
      var zone = btn.parentNode.querySelector('[data-av2-texte]');
      if (!zone) return;
      zone.className = 'av2-x tout';
      btn.setAttribute('hidden', '');
    });

    var tri = sec.querySelector('[data-av2-tri]');
    if (tri) {
      tri.addEventListener('change', function () {
        var copie = items.slice();
        var mode = tri.value;
        if (mode !== 'ordre') {
          copie.sort(function (a, b) {
            var na = parseInt(a.getAttribute('data-av2-note'), 10) || 0;
            var nb = parseInt(b.getAttribute('data-av2-note'), 10) || 0;
            if (na !== nb) return mode === 'haut' ? nb - na : na - nb;
            /* A note egale on garde l'ordre d'origine, sinon deux tris de
               suite ne rendent pas la meme liste. */
            return (parseInt(a.getAttribute('data-av2-ordre'), 10) || 0)
                 - (parseInt(b.getAttribute('data-av2-ordre'), 10) || 0);
          });
        } else {
          copie.sort(function (a, b) {
            return (parseInt(a.getAttribute('data-av2-ordre'), 10) || 0)
                 - (parseInt(b.getAttribute('data-av2-ordre'), 10) || 0);
          });
        }
        for (var i = 0; i < copie.length; i++) { liste.appendChild(copie[i]); }
        afficher(1);
      });
    }

    var panneau = sec.querySelector('[data-av2-form]');
    var ouvre = sec.querySelector('[data-av2-ouvre]');
    var ferme = sec.querySelector('[data-av2-ferme]');
    if (panneau && ouvre) {
      ouvre.addEventListener('click', function () {
        panneau.className = 'av2-form ouvert';
        var champ = panneau.querySelector('input,textarea');
        if (champ) champ.focus();
        panneau.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }
    if (panneau && ferme) {
      ferme.addEventListener('click', function () { panneau.className = 'av2-form'; });
    }
    /* RETOUR D'ENVOI. Shopify recharge la page avec `?contact_posted=true` :
       c'est le seul signal disponible ici, `form.posted_successfully?` ne vit
       que dans le bloc `{% form %}`. On rouvre le panneau et on amene l'oeil
       sur la confirmation, sinon elle reste repliee et l'envoi passe pour un
       echec. */
    if (panneau && window.location.search.indexOf('contact_posted=true') !== -1) {
      panneau.className = 'av2-form ouvert';
      panneau.scrollIntoView({ block: 'center' });
    }

    afficher(1);
    /* LA MESURE DOIT ETRE REFAITE QUAND LES POLICES SONT ARRIVEES, et c'est le
       piege qui a fait apparaitre « voir tout l'avis » sur SIX avis d'une seule
       ligne. Au premier passage, Manrope n'est pas encore charge : le texte est
       rendu dans la police de repli, plus large, il occupe cinq lignes la ou il
       en occupera une, et le bouton s'affiche. La police arrive ensuite, le
       texte se resserre, mais plus personne ne remesure. */
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(mesurerCoupes);
    }
    /* Une largeur qui change modifie le nombre de lignes affichees, donc les
       avis qui debordent. On remesure, sans refaire la pagination. */
    var minuteur;
    window.addEventListener('resize', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(mesurerCoupes, 200);
    }, { passive: true });
  }

  function toutes(racine) {
    var r = racine || document;
    var liste = [].slice.call(r.querySelectorAll('.s-av2'));
    if (r.classList && r.classList.contains('s-av2')) liste.push(r);
    return liste;
  }

  function demarrer() {
    var l = toutes(document);
    for (var i = 0; i < l.length; i++) { armer(l[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    var l = toutes(ev.target);
    for (var i = 0; i < l.length; i++) { armer(l[i]); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prd-00-buybox"] && !Shopify.designMode) return;
  try {
    
/* Carrousel de la galerie et cartes de lot.

   LE CARROUSEL NE CALCULE AUCUNE POSITION : il pousse le defilement natif de la
   piste, qui porte une accroche CSS. Si ce script ne se charge pas, la galerie
   reste utilisable au doigt et au pave tactile. C'est la lecon du 05/08, ou les
   vignettes ne reagissaient pas au clic.

   Quatre points a ne pas defaire :
   1. l'initialisation attend le DOM, Shopify sert ce fichier depuis le head ;
   2. l'editeur recharge une section sans recharger la page, d'ou l'ecoute de
      `shopify:section:load` ;
   3. le drapeau `data-bb3-init` evite de brancher deux fois ;
   4. l'index actif se lit dans `data-bb3-dot`, JAMAIS dans la position du
      bouton dans la liste : points et vignettes portent le meme attribut et
      forment une seule liste melangee, un index de position les desynchroniserait.

   Tous les acces sont scopes par querySelector sur `.s-bb3`, jamais par position
   dans le DOM : le script survit au reordonnancement du 09/08. */
(function () {
  function init(sec) {
    if (!sec || sec.dataset.bb3Init === '1') return;
    sec.dataset.bb3Init = '1';

    var piste = sec.querySelector('[data-bb3-track]');
    var points = sec.querySelectorAll('[data-bb3-dot]');
    if (piste) {
      var pas = function () { return piste.clientWidth; };
      var prev = sec.querySelector('[data-bb3-prev]');
      var next = sec.querySelector('[data-bb3-next]');
      if (prev) prev.addEventListener('click', function () { piste.scrollBy({ left: -pas(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { piste.scrollBy({ left: pas(), behavior: 'smooth' }); });
      points.forEach(function (p) {
        p.addEventListener('click', function () {
          piste.scrollTo({ left: pas() * parseInt(p.dataset.bb3Dot, 10), behavior: 'smooth' });
        });
      });
      /* Le reperage actif suit le defilement, quelle qu'en soit l'origine :
         fleche, point, vignette, doigt ou pave tactile. Un seul endroit decide. */
      piste.addEventListener('scroll', function () {
        var i = Math.round(piste.scrollLeft / (pas() || 1));
        points.forEach(function (p) {
          p.classList.toggle('on', parseInt(p.dataset.bb3Dot, 10) === i);
        });
      }, { passive: true });
    }

    var champ = sec.querySelector('[data-bb3-vid]');
    var prix = sec.querySelector('[data-bb3-price]');
    var cartes = sec.querySelectorAll('[data-bb3-offer]');
    cartes.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.querySelector('input') && c.querySelector('input').disabled) return;
        if (champ) champ.value = c.dataset.vid;
        if (prix) prix.textContent = c.dataset.price;
        cartes.forEach(function (o) { o.classList.remove('on'); });
        c.classList.add('on');
      });
    });
  }

  function tout(racine) {
    (racine || document).querySelectorAll('.s-bb3').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tout(); });
  } else {
    tout();
  }
  document.addEventListener('shopify:section:load', function (e) { tout(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prd-14-avis"] && !Shopify.designMode) return;
  try {
    
/* PAGINATION, TRI, DEPLIEMENT ET FORMULAIRE.
   TOUT EST SOUS `.av2-js`, classe que seul ce script pose : sans lui la section
   affiche la premiere page et rien d'autre, la pagination restant masquee. Un
   visiteur sans JavaScript voit donc six avis complets plutot qu'une liste
   tronquee avec des boutons morts.

   LE DEPLIEMENT NE S'ANNONCE QUE S'IL SERT. `scrollHeight > clientHeight` est
   la seule mesure qui dise si la coupe a vraiment eu lieu : un avis de deux
   lignes n'a rien a deplier, et lui coller un « voir tout l'avis » est le detail
   qui fait faux. La marge de 4 px absorbe l'arrondi sous-pixel. */
(function () {
  function armer(sec) {
    if (!sec || sec.getAttribute('data-av2-arme') === '1') return;
    var liste = sec.querySelector('[data-av2-liste]');
    if (!liste) return;
    sec.setAttribute('data-av2-arme', '1');
    sec.classList.add('av2-js');

    var parPage = parseInt(sec.getAttribute('data-av2-par-page'), 10) || 6;
    var items = [].slice.call(liste.children);
    var boutons = [].slice.call(sec.querySelectorAll('[data-av2-page]'));
    var suivant = sec.querySelector('[data-av2-suivant]');
    var page = 1;

    function pages() {
      return Math.max(1, Math.ceil(items.length / parPage));
    }

    function afficher(p) {
      page = Math.min(Math.max(1, p), pages());
      var debut = (page - 1) * parPage;
      var fin = debut + parPage;
      /* On repart de l'ordre COURANT du DOM et non du tableau d'origine :
         apres un tri, les deux ne coincident plus. */
      var courants = [].slice.call(liste.children);
      for (var i = 0; i < courants.length; i++) {
        if (i >= debut && i < fin) {
          courants[i].removeAttribute('hidden');
        } else {
          courants[i].setAttribute('hidden', '');
        }
      }
      for (var j = 0; j < boutons.length; j++) {
        var actif = parseInt(boutons[j].getAttribute('data-av2-page'), 10) === page;
        boutons[j].className = actif ? 'av2-page on' : 'av2-page';
        if (actif) { boutons[j].setAttribute('aria-current', 'page'); }
        else { boutons[j].removeAttribute('aria-current'); }
      }
      mesurerCoupes();
    }

    /* On ne remonte pas en haut de la PAGE mais en haut de la LISTE, et
       seulement quand elle est deja passee au-dessus de l'ecran : changer de
       page en gardant l'oeil au milieu d'un avis donne l'impression que rien
       ne s'est passe. */
    function recadrer() {
      var haut = liste.getBoundingClientRect().top;
      if (haut < 0) { window.scrollTo({ top: window.scrollY + haut - 90, behavior: 'smooth' }); }
    }

    for (var k = 0; k < boutons.length; k++) {
      (function (b) {
        b.addEventListener('click', function () {
          afficher(parseInt(b.getAttribute('data-av2-page'), 10));
          recadrer();
        });
      })(boutons[k]);
    }
    if (suivant) {
      suivant.addEventListener('click', function () {
        afficher(page >= pages() ? 1 : page + 1);
        recadrer();
      });
    }

    /* DEPLIEMENT. On ne mesure que les avis VISIBLES : un element `hidden` a
       une hauteur nulle, la comparaison y serait toujours fausse et tous les
       boutons apparaitraient. D'ou l'appel a chaque changement de page. */
    function mesurerCoupes() {
      var vus = liste.querySelectorAll('.av2-item:not([hidden])');
      for (var i = 0; i < vus.length; i++) {
        var zone = vus[i].querySelector('[data-av2-texte]');
        var btn = vus[i].querySelector('[data-av2-plus]');
        if (!zone || !btn) continue;
        if (zone.className.indexOf('tout') !== -1) continue;
        if (zone.scrollHeight - zone.clientHeight > 4) {
          btn.removeAttribute('hidden');
        } else {
          btn.setAttribute('hidden', '');
        }
      }
    }

    liste.addEventListener('click', function (ev) {
      var btn = ev.target.closest ? ev.target.closest('[data-av2-plus]') : null;
      if (!btn) return;
      var zone = btn.parentNode.querySelector('[data-av2-texte]');
      if (!zone) return;
      zone.className = 'av2-x tout';
      btn.setAttribute('hidden', '');
    });

    var tri = sec.querySelector('[data-av2-tri]');
    if (tri) {
      tri.addEventListener('change', function () {
        var copie = items.slice();
        var mode = tri.value;
        if (mode !== 'ordre') {
          copie.sort(function (a, b) {
            var na = parseInt(a.getAttribute('data-av2-note'), 10) || 0;
            var nb = parseInt(b.getAttribute('data-av2-note'), 10) || 0;
            if (na !== nb) return mode === 'haut' ? nb - na : na - nb;
            /* A note egale on garde l'ordre d'origine, sinon deux tris de
               suite ne rendent pas la meme liste. */
            return (parseInt(a.getAttribute('data-av2-ordre'), 10) || 0)
                 - (parseInt(b.getAttribute('data-av2-ordre'), 10) || 0);
          });
        } else {
          copie.sort(function (a, b) {
            return (parseInt(a.getAttribute('data-av2-ordre'), 10) || 0)
                 - (parseInt(b.getAttribute('data-av2-ordre'), 10) || 0);
          });
        }
        for (var i = 0; i < copie.length; i++) { liste.appendChild(copie[i]); }
        afficher(1);
      });
    }

    var panneau = sec.querySelector('[data-av2-form]');
    var ouvre = sec.querySelector('[data-av2-ouvre]');
    var ferme = sec.querySelector('[data-av2-ferme]');
    if (panneau && ouvre) {
      ouvre.addEventListener('click', function () {
        panneau.className = 'av2-form ouvert';
        var champ = panneau.querySelector('input,textarea');
        if (champ) champ.focus();
        panneau.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }
    if (panneau && ferme) {
      ferme.addEventListener('click', function () { panneau.className = 'av2-form'; });
    }
    /* RETOUR D'ENVOI. Shopify recharge la page avec `?contact_posted=true` :
       c'est le seul signal disponible ici, `form.posted_successfully?` ne vit
       que dans le bloc `{% form %}`. On rouvre le panneau et on amene l'oeil
       sur la confirmation, sinon elle reste repliee et l'envoi passe pour un
       echec. */
    if (panneau && window.location.search.indexOf('contact_posted=true') !== -1) {
      panneau.className = 'av2-form ouvert';
      panneau.scrollIntoView({ block: 'center' });
    }

    afficher(1);
    /* LA MESURE DOIT ETRE REFAITE QUAND LES POLICES SONT ARRIVEES, et c'est le
       piege qui a fait apparaitre « voir tout l'avis » sur SIX avis d'une seule
       ligne. Au premier passage, Manrope n'est pas encore charge : le texte est
       rendu dans la police de repli, plus large, il occupe cinq lignes la ou il
       en occupera une, et le bouton s'affiche. La police arrive ensuite, le
       texte se resserre, mais plus personne ne remesure. */
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(mesurerCoupes);
    }
    /* Une largeur qui change modifie le nombre de lignes affichees, donc les
       avis qui debordent. On remesure, sans refaire la pagination. */
    var minuteur;
    window.addEventListener('resize', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(mesurerCoupes, 200);
    }, { passive: true });
  }

  function toutes(racine) {
    var r = racine || document;
    var liste = [].slice.call(r.querySelectorAll('.s-av2'));
    if (r.classList && r.classList.contains('s-av2')) liste.push(r);
    return liste;
  }

  function demarrer() {
    var l = toutes(document);
    for (var i = 0; i < l.length; i++) { armer(l[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    var l = toutes(ev.target);
    for (var i = 0; i < l.length; i++) { armer(l[i]); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
